import { Component, EventEmitter, Input, Output } from '@angular/core';
import { normalizeLeadStatus, normalizeLeadType } from 'src/app/utils/lead-status.util';

export interface LeadDetailsExtraField {
  label?: string;
  field_name?: string;
  value?: string;
  key?: string;
}

@Component({
  selector: 'app-lead-details-hover-popup',
  templateUrl: './lead-details-hover-popup.component.html',
  styleUrls: ['./lead-details-hover-popup.component.scss'],
})
export class LeadDetailsHoverPopupComponent {
  @Input() lead: any;
  @Input() extraFields: LeadDetailsExtraField[] = [];
  @Output() closed = new EventEmitter<void>();

  get statusClass(): string {
    const status = normalizeLeadStatus(this.lead?.['lead_status']);
    if (status === 'Closed - Won') {
      return 'won';
    }
    if (status === 'Closed - Lost') {
      return 'lost';
    }
    return 'chip';
  }

  get typeLabel(): string {
    return normalizeLeadType(this.lead?.['lead_type']);
  }

  get statusLabel(): string {
    return normalizeLeadStatus(this.lead?.['lead_status']);
  }

  fieldLabel(field: LeadDetailsExtraField): string {
    return String(field.label || field.value || '').trim();
  }

  fieldKey(field: LeadDetailsExtraField): string {
    return String(field.field_name || field.key || '').trim();
  }

  customFieldValue(field: LeadDetailsExtraField): string {
    const key = this.fieldKey(field);
    if (!key || !this.lead?.fields) {
      return '';
    }
    const value = this.lead.fields[key];
    return value == null ? '' : String(value).trim();
  }

  hasText(value: unknown): boolean {
    return value != null && String(value).trim() !== '';
  }

  onClose(): void {
    this.closed.emit();
  }
}
